import { render } from "./App.vue?vue&type=template&id=8470f20c"
const script = {}

import "./App.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script